import { Link } from 'react-router-dom';
import './Event.css';
import { useEffect, useState } from 'react';

export default function Event({ data }) {
    const apiBase = process.env.NODE_ENV === 'development' ? '/' : process.env.REACT_APP_API_URL_Prod;
    const checkShowStatsApi = apiBase + 'api/Sport/Event/' + data.eventId;
    const [showStats, setShowStats] = useState(false);

    useEffect(() => {
        //since api is not ready for prod use it on dev only
            (async () => {
                try {
                    const headers = {
                        "Authorization": "Bearer 8924cc35-5d20-45f3-8e7e-dcddfc37b43d",
                    };
                    const requestOptions = {
                        method: 'GET',
                        headers
                    };
                    let response = await fetch(checkShowStatsApi, requestOptions);
                    if (response.ok) {
                        let dt = await response.json();
                        if (dt) setShowStats(dt.components);
                    }else {
                        throw new Error(response.status);
                    }
                } catch (error) {
                    console.log(error);
                    setShowStats(false);
                }
            })();
    }, [data.eventId])

    if (data && data.listOfParticipatingTeams) {
        data.listOfParticipatingTeams.sort((a, b) => {
            if (a.isHomeTeam && !b.isHomeTeam) {
                return -1;
            } else if (!a.isHomeTeam && b.isHomeTeam) {
                return 1;
            } else {
                return 0;
            }
        })
    }
    return (
        <div className="eventContainer">
            <div className='team'>
                {data && data.listOfParticipatingTeams.map(team => (
                    <div key={team.teamId} className="team-info">
                        <img src={team.teamLogoUrl} alt="team-logo" className="logo" />
                        <p>{team.teamName}</p>
                    </div>
                ))}
            </div>
            {showStats ? (<Link className='stats-btn' to={`/stats/${data.eventId}`}>Match Stats</Link>) : ''}
        </div>
    )
}
